import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import BigNumber from 'bignumber.js'
import {
  Heading,
  CardBody,
  Flex,
  CardHeader,
  Button,
  Progress,
  UsersIcon,
  CalendarIcon,
  WalletsIcon,
  RadialChartIcon,
  ScanIcon,
  CoinsIcon,
  Text,
  useMatchBreakpoints
} from 'penguinfinance-uikit2'
import { useWeb3React } from '@web3-react/core'
import { usePriceAvaxUsdt, useKittyLaunchpad, useKittyBoosterRocket, useKassandraLaunchpad, useKassandraBoosterRocket, useBoofiLaunchpad, useLaunchpad, useClubPenguinFarms } from 'state/hooks'
import Balance from 'components/Balance'
import { getBalanceNumber } from 'utils/formatBalance';
import useTokenBalance from 'hooks/useTokenBalance'
import { getIPefiAddress } from 'utils/addressHelpers'

const FCard = styled.div`
  align-self: baseline;
  cursor: pointer;
  background: white;
  border-radius: 18px;
  box-shadow: 4px 4px 32px rgba(165, 165, 165, 0.25);
  backdrop-filter: blur(38px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  width: 100%;
  svg {
    path {
      stroke: ${({ theme }) => (theme.isDark ? '#313131' : '#313131')};
    }
  }
  @media (min-width: 576px) {
    min-width: 450px;
  }
  @media (max-width: 576px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`

const StyledCardHeader = styled(CardHeader)`
  background: #392771;
  padding: 16px;
  border-radius: 16px 16px 0 0;

  @media (min-width: 1200px) {
    padding: 26px 28px 20px 25px;
  }
`

const StyledCardBody = styled(CardBody)`
  padding: 14px;

  @media (min-width: 768px) {
    padding: 20px;
  }
  @media (min-width: 1200px) {
    padding: 24px;
  }
`

const HeadingText = styled(Heading)`
  font-family: "Kanit";
  color: #342c6d;
  font-size: 12px;
  font-weight: bold;

  @media (min-width: 1200px) {
    font-size: 18px;
  }
`

const LabelText = styled.span`
  font-size: 14px;
  color: #313131;

  @media (max-width: 640px) {
    font-size: 9px;
    line-height: 13px;
  }
`

const LabelText2 = styled.span`
  font-size: 12px;
  color: #313131;

  @media (max-width: 640px) {
    font-size: 8px;
    line-height: 12px;
  }
`

const StyledButton = styled(Button)`
  background-color: #564bab;
  color: white;
  border-radius: 4px;
  white-space: nowrap;
  margin-bottom: 8px;
  padding: 16.5px 48px;
  font-family: Fira Code;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;

  img {
    margin-left: 8px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 640px) {
    width: 81.38px;
    height: 30.1px;
    font-size: 11.1481px;
    line-height: 15px;
  }
`

const GradientText = styled(Balance)`
  background-image: linear-gradient(45deg, #e83789, #99378d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-background-clip: text;
  -moz-text-fill-color: transparent;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 42px;
`

const GradientSubText = styled(Balance)`
  background-image: linear-gradient(45deg, #99378d, #483692);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-background-clip: text;
  -moz-text-fill-color: transparent;
  font-style: normal;
  font-weight: normal;
  font-size: 20.8136px;
  line-height: 31px;
`

const TextValue = styled(Text)`
  font-size: 18px;
  margin-top: 15;
  font-weight: 500;
  color: #392171;

  @media (max-width: 640px) {
    font-size: 9px;
    line-height: 14px;
  }
`

const CardSubHeading = styled(Heading)`
  font-family: "Kanit";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  color: #ebf6ff;

  @media (max-width: 640px) {
    font-size: 8px;
    line-height: 12px;
  }
`

const CardHeading = styled(Heading)`
  font-family: "Kanit";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #ebf6ff;

  @media (min-width: 640px) {
    font-size: 28px;
    line-height: 42px;    
  }
`

const StyledValueText = styled(Text)`
  font-family: "Fira Code";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  margin-left: 5px;
  color: #4a3692;

  @media (max-width: 640px) {
    font-size: 8px;
    line-height: 11px;
    margin-left: 2px;
  }
`

const IdoLogo = styled.img`
  height: 36px;
  margin-right: 8px;

  @media (min-width: 640px) {
    height: 60px;
  }
`

const ProgressWrapper = styled.div`
  div {
    height: 16px;
    font-size: 12px;

    @media (min-width: 640px) {
      height: 24px;
      font-size: 16px;
    }
    div {
      border-radius: 28px;
      background: #483692;
      z-index: 1;

      &:nth-last-child(3) {
        background: transparent;
        z-index: 2;
      }
      &:last-child {
        background: #7E7EE2;
        z-index: 0;
      }
    }
  }
`

const KITTY_TIERS = ['GrumpyCat', 'AstroCat', 'NyanCat'];
const SHERPA_TIERS = ['Astronaut', 'Penguineer', 'Spacelord'];
const BOOFI_TIERS = ['Ghoul', 'Reaper', 'Demonlord'];
const KACY_TIERS = ['Poseidon', 'Hades', 'Zeus', 'Kronos'];

const BinaryStatsCard = ({ idoData }) => {
  const history = useHistory();
  const { account } = useWeb3React()
  const avaxPriceInUsd = usePriceAvaxUsdt().toNumber()
  const launchpadData = useKittyLaunchpad(account)
  const { totalTokensSold } = useKittyBoosterRocket(account)
  const totalTokensSoldInUsd = Number(totalTokensSold) * idoData.tokenPrice
  const kassandraLaunchpadData = useKassandraLaunchpad(account)
  const boofiLaunchpadData = useBoofiLaunchpad(account)
  const sherpaLaunchpadData = useLaunchpad(account)
  const { totalTokensSold: kassandraTotalTokensSold } = useKassandraBoosterRocket(account)
  const kassandraTotalTokensSoldInUsd = Number(kassandraTotalTokensSold) * idoData.tokenPrice

  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl

  // iPefi balance in wallet
  const iPefiBalanceInWallet = useTokenBalance(getIPefiAddress())
  // iPefi staked balance in clubs
  const clubFarms = useClubPenguinFarms(account)
  const getIPefiStakedBalanceInClubs = () => {
    let _iPefiStakedBalanceInClubs = new BigNumber(0)
    clubFarms.map((clubFarm) => {
      const { userData } = clubFarm
      if (userData) {
        _iPefiStakedBalanceInClubs = _iPefiStakedBalanceInClubs.plus(new BigNumber(userData.stakedBalance))
      }
      return clubFarm
    })
    return _iPefiStakedBalanceInClubs
  }

  let { participants, saleProgress, soldTokenAmount, allocation } = idoData
  let tierName = 'None'
  if (idoData.tokenSymbol === 'KITTY') {
    participants = launchpadData.registeredPenguins
    saleProgress = idoData.isCompleted ? 100 : ((100 * totalTokensSoldInUsd) / idoData.totalRaised).toFixed(2)
    soldTokenAmount = `${(totalTokensSold / 1000000).toFixed(2)}M`
    allocation = getBalanceNumber(new BigNumber(launchpadData.allocation));

    const staked = iPefiBalanceInWallet.plus(getIPefiStakedBalanceInClubs())
    const launchpadStaked = getBalanceNumber(new BigNumber(staked))
    const hasTier = launchpadStaked >= 250
    // const hasTier = true;
    tierName = hasTier && launchpadData.yourPenguinTier >= 1 ? KITTY_TIERS[launchpadData.yourPenguinTier - 1] : 'None'
  } 

  if (idoData.tokenSymbol === 'KACY') {
    participants = kassandraLaunchpadData.registeredPenguins
    saleProgress = idoData.isCompleted ? 100 : ((100 * kassandraTotalTokensSoldInUsd) / idoData.totalRaised).toFixed(2)
    soldTokenAmount = `${(kassandraTotalTokensSold / 1000000).toFixed(2)}M`
    allocation = getBalanceNumber(new BigNumber(kassandraLaunchpadData.allocation))
    
    const staked = iPefiBalanceInWallet.plus(getIPefiStakedBalanceInClubs())
    const launchpadStaked = getBalanceNumber(new BigNumber(staked))
    const hasTier = launchpadStaked >= 500
    // const hasTier = true;
    tierName = hasTier && kassandraLaunchpadData.yourPenguinTier >= 1 ? KACY_TIERS[kassandraLaunchpadData.yourPenguinTier - 1] : 'None'
  }

  if (idoData.tokenSymbol === 'SHERPA') {
    allocation = getBalanceNumber(new BigNumber(sherpaLaunchpadData.allocation));    
    const launchpadStaked = getBalanceNumber(new BigNumber(sherpaLaunchpadData.stakedBalance))
    const hasTier = launchpadStaked >= 300
    tierName = hasTier ? SHERPA_TIERS[sherpaLaunchpadData.yourPenguinTier] : 'None'
  }

  if (idoData.tokenSymbol === 'BOOFI') {
    allocation = getBalanceNumber(new BigNumber(boofiLaunchpadData.allocation));
    const launchpadStaked = getBalanceNumber(new BigNumber(boofiLaunchpadData.stakedBalance))
    const hasTier = launchpadStaked >= 500
    tierName = hasTier ? BOOFI_TIERS[boofiLaunchpadData.yourPenguinTier] : 'None'
  }

  const handleOpenIdo = () => {
    history.push(idoData.link);
  };

  return (
    <FCard>
      <StyledCardHeader>
        <Flex justifyContent="space-between" alignItems="center">
          <Flex>
            {/* <StyledImg src="/images/home-v2/kitty.svg" /> */}
            <Flex>
              {/* <CardHeading>{idoData.title}</CardHeading> */}
              <div>
                <IdoLogo
                  src={`/images/home-v2/idos/${idoData.whiteLogo}`
                    // isDark
                    //   ? `/images/home-v2/logos/${idoData.darkLogo}`
                    //   : `/images/launchpad-v2/logos/${idoData.whiteLogo}`
                  }
                  alt={idoData.title}
                  height={60}
                />
              </div>
              <div>
                <CardHeading>{idoData.title}</CardHeading>
                <CardSubHeading>1 {idoData.tokenSymbol} = {`${(idoData.tokenPrice / avaxPriceInUsd).toFixed(5)} AVAX`}</CardSubHeading>
              </div>
            </Flex>
          </Flex>
          <StyledButton onClick={handleOpenIdo} id="harvest-pefi" scale="md">
            Open
          </StyledButton>
        </Flex>
      </StyledCardHeader>
      <StyledCardBody>
        <HeadingText fontSize='20px'>Total Raised</HeadingText>
        {/* <Flex alignItems="flex-end">
          <GradientText>$200,000/</GradientText>
          <GradientSubText>$200,000</GradientSubText>
        </Flex> */}
        {idoData.isCompleted ? (
          <Flex>
            <GradientText
              fontSize={isMobile ? '24px' : "28px"}
              color="#C0378C"
              fontWeight="600"
              prefix="$"
              decimals={0}
              value={Number(idoData.totalRaised)}
            />
            <GradientSubText
              fontSize={isMobile ? '24px' : "28px"}
              color="#C0378C"
              fontWeight="600"
              prefix=" / "
              decimals={0}
              value={Number(idoData.totalRaised)}
            />
          </Flex>
        ) : (
          <Flex>
            <GradientText
              fontSize={isMobile ? '24px' : "28px"}
              color="#C0378C"
              fontWeight="600"
              prefix="$"
              decimals={0}
              value={idoData.tokenSymbol === 'KACY' ? Number(kassandraTotalTokensSoldInUsd) : Number(totalTokensSoldInUsd)}
            />
            <GradientSubText
              fontSize={isMobile ? '24px' : "28px"}
              color="#C0378C"
              fontWeight="600"
              prefix=" / $"
              decimals={0}
              value={Number(idoData.totalRaised)}
            />
          </Flex>
        )}
        <Flex justifyContent="space-between" alignItems="center" mb={3} mt={3}>
          <Flex flexDirection="column">
            <Flex alignItems="center">
              <UsersIcon width={20} height={20} color="none" />
              <LabelText style={{ marginLeft: 5 }}>Participants</LabelText>
            </Flex>
            <TextValue>{participants}</TextValue>
          </Flex>
          <Flex flexDirection="column">
            <Flex alignItems="center">
              <CalendarIcon color="none" />
              <LabelText style={{ marginLeft: 5 }}>Start Date</LabelText>
            </Flex>
            <TextValue>{idoData.startDate}</TextValue>
          </Flex>
          <Flex flexDirection="column">
            <Flex alignItems="center">
              <WalletsIcon color="none" />
              <LabelText style={{ marginLeft: 5 }}>Token Price</LabelText>
            </Flex>
            <TextValue>{idoData.tokenPrice > 0 ? `$${idoData.tokenPrice}` : '???'}</TextValue>
          </Flex>
        </Flex>
        <Text fontSize={isMobile ? '10px' : '13px'} fontWeight='600' color='#392171' mb='8px'>SALE PROGRESS</Text>
        <ProgressWrapper>
          <Progress primaryStep={saleProgress} secondaryStep={100} showProgressBunny progressLabel={`${saleProgress}% Tokens sold`} />
        </ProgressWrapper>
        <Flex justifyContent="space-between" mt={2} style={{ paddingTop: 20, borderTop: '1px solid #DCDCDC' }}>
          <Flex alignItems="flex-start">
            <RadialChartIcon color="none" />
            <Flex flexDirection="column" ml={1}>
              <Flex alignItems='center'>
                <LabelText2>Tokens Sold: </LabelText2>
                <StyledValueText>{soldTokenAmount}</StyledValueText>
              </Flex>
              <Flex alignItems='center'>
                <LabelText2>Tokens Distribution:</LabelText2>
                <StyledValueText>{idoData.distributedTokenAmount}</StyledValueText>
              </Flex>
            </Flex>
          </Flex>
          <Flex alignItems="flex-start">
            <ScanIcon color="none" />
            <Flex ml={1} alignItems='center'>
              <LabelText2>Sale progress:</LabelText2>
              <StyledValueText>{`${saleProgress}%`}</StyledValueText>
            </Flex>
          </Flex>
          <Flex alignItems="flex-start">
            <CoinsIcon color="none" />
            <Flex flexDirection="column" ml={1}>
              <Flex alignItems='center'>
                <LabelText2>Your Allocation:</LabelText2>
                <StyledValueText>{allocation.toFixed(2)}</StyledValueText>
              </Flex>
              <Flex alignItems='center'>
                <LabelText2>Your Tier:</LabelText2>
                <StyledValueText>{tierName}</StyledValueText>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </StyledCardBody>
    </FCard>
  )
}

export default BinaryStatsCard
